import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import headerActions from './../../reusable/Header/Header.actions';
import LoadingSpinner from './../../reusable/LoadingSpinner/LoadingSpinner.index.jsx';
import DeliveryIcons from './../../reusable/DeliveryIcons/DeliveryIcons';
import AboutThisSource from './SanctionReports.SanctionType.AboutThisSource';
import ContentSummary from './SanctionReports.SanctionType.ContentSummary';
import NavigationBox from './../../reusable/NavigationBox/NavigationBox';
import storage from "../../utils/storage";
import api from "../../api/EsSanctions.api";

class SanctionReports extends Component {

    static propTypes = {
        items: PropTypes.array,
        index: PropTypes.number,
        totalCount: PropTypes.number,
        router: PropTypes.any,
        entityName: PropTypes.string
    };

    static defaultProps = {
        html: {}
    };

    constructor(props) {
        super(props);

        this.createHtmlBody = this.createHtmlBody.bind(this);
        this.getSanctionType = this.getSanctionType.bind(this);
        this.goBack = this.goBack.bind(this);
        this.onChangeArticle = this.onChangeArticle.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeaderContent(
            <div>{this.props.entityName}: <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.overlayHeader"/></div>,
            'sanctionsfulldoctips-field?lbu=US&locale=en_US&audience=all'
        );

        window.scrollTo(0, 0);

        if(!this.props.items[this.props.index]) {
            this.goBack();
        }

        let auth = storage.getObject("lnei");
        let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");
        if (isWam) {
            // for WAM trigger synthetic royalty event
            api.triggerBilling(this.props.items[this.props.index].id,this.props.items[this.props.index].pcsi);
        }

    };

    getSanctionType() {

        if(!!this.props.items[this.props.index]) {
            let auth = storage.getObject("lnei");
            let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");
            if (isWam === true) {
                let sanctionType = '';

                let el = document.createElement( 'html' );
                el.innerHTML = this.props.items[this.props.index].html;

                const publicationName = el.getElementsByTagName("publicationname");
                // console.log("=============888888");
                // console.log(publicationName[0].innerText.trim());
                // for (let i = 0; i < publicationName.length; i++) {
                //     if (publicationName[i].name === 'sourceName') {
                //         return publicationName[i].content;
                //     }
                // }
                return publicationName[0].innerText.trim();
            } else {
                let sanctionType = '';

                let el = document.createElement( 'html' );
                el.innerHTML = this.props.items[this.props.index].html;

                const publicationName = el.getElementsByTagName("meta");
                for (let i = 0; i < publicationName.length; i++) {
                    if (publicationName[i].name === 'sourceName') {
                        return publicationName[i].content;
                    }
                }
                return sanctionType;
            }
        }

    }

    createHtmlBody() {
        if(!!this.props.items[this.props.index]) {
            let el = document.createElement( 'html' );
            el.innerHTML = this.props.items[this.props.index].html;
            const articleBody = el.getElementsByTagName("body")[0].innerHTML;

            return {__html: articleBody};
        }

    };

    getBackLocation() {
        let location = "/start"
        if (window.location.href.indexOf('?backRoute=') > -1) {
            location =  window.location.href.substr(window.location.href.indexOf('?backRoute=') + 11);
        }
        return location
    }

    goBack() {
        this.props.router.push(this.getBackLocation());
    }

    onChangeArticle(index) {
        let auth = storage.getObject("lnei");
        let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");
        if (isWam) {
            // for WAM trigger synthetic royalty event
            api.triggerBilling(this.props.items[index].id,this.props.items[index].pcsi);
        }

        if (index === this.props.items.length - 2 && this.props.items.length !== this.props.totalCount) {
            this.props.loadItems(this.props.entityName);
        }
        if (this.getBackLocation() === "/start") {
            this.props.router.push('/sanctions-reports/report/' + index);
        } else {
            this.props.router.push('/sanctions-reports/report/' + index + "?backRoute=" + this.getBackLocation());
        }
    }

    render() {

        const sanctionType = this.getSanctionType();

        return (
            <div className="sanction-reports">

                <div className="previous-page-link-row no-print">
                    <span className="la-TriangleLeft"></span>
                    <span className="action-link" onClick={this.goBack}>
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                    </span>
                </div>

                    <div>
                        <div className="sanction-reports__top-controls">

                            <div className="sanction-reports__top-controls--delivery-icons">
                                { this.props.items[this.props.index] &&
                                        <DeliveryIcons html={this.props.items[this.props.index].html}/> }
                            </div>

                            <div className="sanction-reports__top-controls--google-and-navigation">

                                <NavigationBox total={this.props.totalCount}
                                               current={this.props.index}
                                               onChange={this.onChangeArticle}
                                               isLoading={!this.props.items[this.props.index]} />
                            </div>

                        </div>

                        <div className="sanction-reports__page-content">
                            <div className="sanction-reports__page-content--article-content">
                                {this.props.items[this.props.index] ? (
                                        <p className="article-body" dangerouslySetInnerHTML={this.createHtmlBody()} />
                                ) : <LoadingSpinner isVisible={true} isInner="true" /> }
                            </div>
                            {
                                sanctionType ?
                                    <div className="sanction-reports__page-content--source-information">

                                        <div className="about-this-source">
                                            <div className="about-this-source__header">
                                                <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.aboutThisSource" />
                                            </div>
                                            <AboutThisSource sanctionType={sanctionType} />
                                        </div>

                                        <div className="content-summary">
                                            <div className="content-summary__header">
                                                <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.detailsPage.contentSummary" />
                                            </div>
                                            <ContentSummary sanctionType={sanctionType} />
                                        </div>

                                    </div>
                                    :
                                    <div className="sanction-reports__page-content--source-information">{sanctionType}</div>
                            }
                        </div>
                    </div>
            </div>
        );

    };

}

export default SanctionReports;



// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionReports/SanctionReports.index.jsx